import screenbanner from "./images/background/1.jpg";
import mobilrbanner from "./images/background/2.jpg";
import one from "./images/property/one.jpg";

export const BannerData = {
  screenbanner: screenbanner,
  mobilebanner: mobilrbanner,
};

export const LocationData = {
  taglineheading: "Property in Central Pune",
  locationtag: "",
  location: [
    {
      name: "Aditya Birla Wellesley Road ",
      image: one,
      price: "On Request",
      location: "Wellesley Road",
      bed: "1,2,3 & 4 BHK",
      size: "....",
      url: `/aditya-birla-wellesley`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};
